export default __webpack_public_path__ + "static/media/jolleria castillo Masaya3.363d35a3.jpeg";